import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import InputLabel from '@hobs/components/InputLabel';
import Styles from './InfoPanel.module.scss';
import InformationTooltip from '../InformationToolTip';

const InfoPanel = ({
  children,
  title,
  titleIndicationMessage,
  detailsIndicationMessage,
  toolTipInformation,
  tooltipStartDisabled,
  catalogItemId,
  code
}) => {
  const [expanded, setExpanded] = useState(false);
  const contentRef = React.createRef();

  const onExpand = event => {
    if (event.currentTarget != event.target) {
      return;
    }
    !expanded && setExpanded(true);
  };

  useEffect(() => {
    setExpanded(isContentFullyVisible());
  }, []);

  const isContentFullyVisible = () => {
    const titleHeight = 15;
    const textLineHeight = 20;
    const numberOfLines = 3;
    const maxHeightWithoutOverlay = textLineHeight * numberOfLines + titleHeight;
    const contentHeight = contentRef.current.scrollHeight;
    return contentHeight <= maxHeightWithoutOverlay;
  };

  return (
    <div
      onClick={onExpand}
      className={classnames(Styles.container, {
        [Styles.expanded]: expanded
      })}
    >
      <div onClick={onExpand} ref={contentRef} className={Styles.content}>
        <div className={Styles.title}>
          <InputLabel indicationMessage={titleIndicationMessage} />
          {title}
          {code && <> [{code}]</>}
        </div>
        <InputLabel indicationMessage={detailsIndicationMessage} />
        {children}
      </div>
      {toolTipInformation && (
        <InformationTooltip
          toolTipInformation={toolTipInformation}
          catalogItemId={catalogItemId}
          startDisabled={tooltipStartDisabled}
        ></InformationTooltip>
      )}
    </div>
  );
};

InfoPanel.propTypes = {
  title: PropTypes.string,
  children: PropTypes.any,
  titleIndicationMessage: PropTypes.object,
  detailsIndicationMessage: PropTypes.object,
  code: PropTypes.string
};

export default InfoPanel;
